import type React from 'react';
import { checkDescription } from '@widgets/shared/descriptionEditor/helpers.ts';
import { AuthorCard } from '@features/common/AuthorCard/index.tsx';
import type { Program } from '@shared/types/programs';
import DescriptionViewer from '@shared/ui/viewer-note-editor-content/description-viewer/index.tsx';
import * as st from './ProgramLanding.module.scss';

type Props = {
  program?: Program;
};

const ProgramLanding: React.FC<Props> = ({ program }) => {
  return (
    <div className={st.wrapper}>
      {program && (
        <>
          <h1 className={st.title}>{program?.title}</h1>
          <AuthorCard author={program.author} className={st.author} />
          {checkDescription(program?.description) && (
            <DescriptionViewer
              isOpenInit={program?.first_open}
              className={st.description}
              description={program?.description}
              isShouldHideButtonOnFull
            />
          )}
        </>
      )}
    </div>
  );
};

export default ProgramLanding;
